<script>
import OrdersList from "@/components/orderslist"
import CustomersApi from "@/services/customers-api";
import { readOrdersListState, saveOrdersListState } from "@/ordersListState";

/**
 * Orders-list component
 */
export default {
  props :{
    
    propShowDrafts: {
      type: Boolean,
      default:  false//() => ({})
    },
   
  },

  computed: {
    customerPortalName(){
      return process.env.VUE_APP_CUSTOMER_PORTAL_NAME
    },
    role() {
      return this.$cookies.get('userr');
    },

      orderMenuStatusOptions() {
        const options = [
          { name: this.$t('ordersMenu.statusLabel.new') + " / " + this.$t('ordersMenu.statusLabel.inPreparation'), value: 1 }
        ];

        if (process.env.VUE_APP_FEATURE_FILTRED_BY_EXTERNAL_ORDER_STATUS) {
          options.push(
            { name: this.$t(process.env.VUE_APP_FEATURE_ESTIMATION_DELIVERED_ENABLED === 'true' ? 'ordersMenu.statusLabel.delivered' : 'ordersMenu.statusLabel.beingDeleverd'), value: 3 }, // Omnipharm: same label as the status badge ("Prête pour Livraison")
            { name: this.$t('ordersMenu.statusLabel.orderIsShipped'), value: -3 }
          );
        } else {
          options.push(
            { name: this.$t('ordersMenu.statusLabel.alldelivered'), value: 3 }
          );
        }

          options.push(
            { name: this.$t('ordersMenu.statusLabel.canceled'), value: 4 }
          );

        return options;
      }

  },

  mounted(){

    this.isAdmin=!this.role && this.role != 0;
   //if(sessionStorage.getItem("privileges")!=null){
      this.privileges= true; //sessionStorage.getItem("privileges")
      this.isAdmin= true; //this.privileges.includes(Priviliges[0]["Admin_Role"] )
   // }

    if(this.role==1 || this.role==2){
      this.getCustomers()
    }

     
  },

  components: { OrdersList},
  data() {
    const saved = readOrdersListState().filters || {};
    return {
      selected: saved.selected || null,
      
      selectedState: saved.selectedState || null,
      status: saved.selectedState ? saved.selectedState.value : null,
      customersList:[],
      selectedCustomer: saved.selected ? saved.selected.id : null,
      end: saved.end || null,
      start: saved.start || null,
      showDrafts: saved.showDrafts || null,
      exportOrdersInProgress: false,
      showUnsynchronisedOrders: saved.showUnsynchronisedOrders || null,
      privileges:"",
      isAdmin:false,

      selectedChannel: saved.selectedChannel || null,
      channel: saved.selectedChannel ? saved.selectedChannel.value : null,
    };
  }, 

  beforeDestroy() {
    saveOrdersListState({
      filters: {
        selected: this.selected,
        selectedState: this.selectedState,
        selectedChannel: this.selectedChannel,
        start: this.start,
        end: this.end,
        showDrafts: this.showDrafts,
        showUnsynchronisedOrders: this.showUnsynchronisedOrders,
      }
    });
  },
  methods:{
    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
        response => {
          this.customersList=response;
        }
      )
    },

    exportEXCEL(showDetails){
      this.exportOrdersInProgress = true;
      this.$refs.ordersList.exportOrdersListExcel(showDetails)
      .then(() => {
          this.exportOrdersInProgress = false;
      })
    }

  },
    watch: {
        selected: function() {
            this.selectedCustomer = this.selected ? this.selected.id : null
        },

        selectedState: function() {
            this.status = this.selectedState ? this.selectedState.value : null
        },

        selectedChannel: function() {
            this.channel = this.selectedChannel ? this.selectedChannel.value : null
        },

        showDrafts: function(){
        },

        start: function(){

        },

        end: function(){

        },

        showUnsynchronisedOrders:function(){
        },

        role: function() {
          this.isAdmin=!this.role && this.role != 0;
   
          if(this.role==1 || this.role==2){
            this.getCustomers()
          }
        },

        

    }       
    }

</script>
<style>

.style-vselect .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

   

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.6;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }

</style>
<template>
      <div>
        <div class="row mt-4 ">
          <div class="col-12  " >
              <b-button variant="info" @click.prevent="exportEXCEL(true)" :disabled="exportOrdersInProgress " class="float-right mb-4 ml-3">
                <b-spinner small :class="exportOrdersInProgress ? 'mr-1' : 'd-none'"></b-spinner>
                  <i class="fas fa-file-excel text-white font-size-16 m-0 p-0 font-weight-bold align-middle mr-2"></i> 
                  <span class=" font-weight-bold text-white text-uppercase">{{$t('ordersMenu.list.exportDetails')}} </span>
              </b-button>
              <b-button variant="success" @click.prevent="exportEXCEL(false)" :disabled="exportOrdersInProgress" class="float-right mb-4">
                <b-spinner small :class="exportOrdersInProgress ? 'mr-1' : 'd-none'"></b-spinner>
                  <i class="fas fa-file-excel text-white font-size-16 m-0 p-0 font-weight-bold align-middle mr-2"></i> 
                  <span class=" font-weight-bold text-white text-uppercase">{{$t('ordersMenu.list.exportList')}} </span>
              </b-button>
          </div>
        </div>
        <div class="row pt-4 pb-2">
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12">
            <b-form-checkbox v-if="role==1" v-model="showUnsynchronisedOrders" switch class="mb-1 float-md-left">
              <label :class="showUnsynchronisedOrders ? 'text-primary' : 'text-muted'">{{$t('ordersMenu.showUnsynchronisedOrders')}}</label>
            </b-form-checkbox>
          </div>
          <!-- <div class="col-xl-6 col-lg-6 ">
          </div> -->
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12">
            <b-form-checkbox v-if="role==1" v-model="showDrafts" switch class="mb-1 float-md-right">
              <label :class="showDrafts ? 'text-primary' : 'text-muted'">{{$t('ordersMenu.showDrafts.text1')}} <strong>{{$t('ordersMenu.showDrafts.text2')}} </strong> {{$t('ordersMenu.showDrafts.text3')}} </label>
            </b-form-checkbox>
          </div>
        </div>
        <!-- <div class="row pt-2">
          <div class="col-xl-9 col-lg-9 ">
          </div>
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12">
            <b-form-checkbox v-if="isAdmin" v-model="showUnsynchronisedOrders" switch class="mb-1 float-md-right">
              <label>{{$t('ordersMenu.showUnsynchronisedOrders')}}</label>
            </b-form-checkbox>
          </div>
        </div> -->
        <div  class="row mt-2">
            <div v-if="role==1"  class="col-md-3 col-xs-12 pr-md-4 ">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
                <v-select class="style-vselect-big" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selected">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div>
            

            <div class="col-md-2 col-xs-12 pr-md-4">
              <b-form-group :label="$t('lists.status.filter')" label-for="">
                  <v-select class="style-vselect-big" style="font-size:1.2em;" :options="orderMenuStatusOptions" 
                  :placeholder="$t('lists.status.label')" label="name" v-model="selectedState" :searchable="false">
                  <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                  </v-select>
              </b-form-group>
              </div>



              <div class="col-md-2 col-xs-12 pr-md-4">
              <b-form-group label="Filtrer par Canal" label-for="">
                  <v-select class="style-vselect-big" style="font-size:1.2em;" :options="[{name : this.customerPortalName, value: 1},{name :'Téléphone', value: 2}]" 
                  placeholder="Canal de commandes" label="name" v-model="selectedChannel" :searchable="false">
                  <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                  </v-select>
              </b-form-group>
            </div> 

            <div class="col-md-2 col-xs-12 pr-md-4">
            <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>

            <div class="col-md-2 col-xs-12 pr-md-4">
            <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')" label-for="">
                <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            

            </div>


        <OrdersList ref="ordersList"  :isAllOrders="false"  :channel.sync=this.channel  :status.sync=this.status :customerId.sync=this.selectedCustomer :showDrafts="showDrafts" :start=start :end=end :showUnsynchronisedOrders.sync=showUnsynchronisedOrders :persistState="true" />
      </div>
</template>
